module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/sofa/sofa.mtl";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/sofa/sofa.mtl
// module id = 631
// module chunks = 0